import { render, staticRenderFns } from "./jmdxt.vue?vue&type=template&id=7f2613fc&scoped=true&"
import script from "./jmdxt.vue?vue&type=script&lang=js&"
export * from "./jmdxt.vue?vue&type=script&lang=js&"
import style0 from "./jmdxt.vue?vue&type=style&index=0&id=7f2613fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2613fc",
  null
  
)

export default component.exports